import App from 'app/app.js';
import 'app/service/StorageService.js';
import 'app/action/SessionTimeoutAction.js';
import 'app/action/DeserializeAction.js';

function OrderStatusStore(StorageService, SessionTimeoutAction, DeserializeAction) {
  var selectedOrderDetails;
  this.orderLookupParam = { email: '', orderNumber: '' };

  this.setSelectedOrderDetails = function (orderDetails) {
    selectedOrderDetails = orderDetails;
    this.updateStorage();
  };

  this.getSelectedOrderDetails = function () {
    return selectedOrderDetails;
  };

  this.setOrderStatusParam = function (email) {
    this.orderLookupParam.email = email;
    this.updateStorage();
  };

  this.getOrderStatusParam = function () {
    return this.orderLookupParam;
  };

  this.clearAll = function () {
    selectedOrderDetails = null;
    this.orderLookupParam = { email: '', orderNumber: '' };
    this.updateStorage();
  };

  this.updateStorage = function () {
    StorageService.setData('orderStatusDetails', {
      selectedOrderDetails: selectedOrderDetails,
      orderLookupParam: this.orderLookupParam
    });
  };

  this.onDeserialized = function (type, data) {
    if (!!data && !!data.orderStatusDetails) {
      selectedOrderDetails = data.orderStatusDetails.selectedOrderDetails;
      this.orderLookupParam = data.orderStatusDetails.orderLookupParam;
    }
  };

  SessionTimeoutAction.register(this.clearAll.bind(this));
  DeserializeAction.register(this.onDeserialized.bind(this));
}

App.service('OrderStatusStore', ['StorageService', 'SessionTimeoutAction', 'DeserializeAction', OrderStatusStore]);

App.run([
  'OrderStatusStore',
  function (OrderStatusStore) {
    // eagerly initialize the store so that event listeners are registered
  }
]);
